/**
 * Auth helpers for The Bothy (admin) area.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH. We derive the redirect from window.location.origin
 * so it always returns to the exact domain the user is on.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BOTHY_PATH = '/the-bothy';
export const ACCOUNT_PATH = '/account';

/** Build the Emergent OAuth URL and redirect the browser to it. */
export function startGoogleSignIn() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
  // THIS BREAKS THE AUTH.
  const redirectUrl = `${window.location.origin}${BOTHY_PATH}`;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

/** Customer-facing Google sign-in — same provider, different return path. */
export function startCustomerGoogleSignIn() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
  // THIS BREAKS THE AUTH.
  const redirectUrl = `${window.location.origin}${ACCOUNT_PATH}`;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

/** Exchange a one-time session_id (from URL fragment) for a server session. */
export async function processSessionId(sessionId) {
  const res = await axios.post(
    `${API}/auth/session`,
    { session_id: sessionId },
    { withCredentials: true },
  );
  return res.data;
}

/** Fetch the currently-signed-in user. Returns null when unauthenticated. */
export async function fetchMe() {
  try {
    const res = await axios.get(`${API}/auth/me`, { withCredentials: true });
    return res.data;
  } catch {
    return null;
  }
}

export async function logout() {
  try {
    await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
  } catch { /* ignore */ }
}

// ───── Admin data helpers ─────
const admin = (path, opts = {}) =>
  axios({ url: `${API}/admin${path}`, withCredentials: true, ...opts });

export const adminApi = {
  enquiries: () => admin('/enquiries').then((r) => r.data),
  subscribers: () => admin('/subscribers').then((r) => r.data),
  stats: () => admin('/stats').then((r) => r.data),
  marketingEvents: () => admin('/marketing-events').then((r) => r.data),
  createMarketingEvent: (payload) =>
    admin('/marketing-events', { method: 'POST', data: payload }).then((r) => r.data),
  deleteMarketingEvent: (id) =>
    admin(`/marketing-events/${id}`, { method: 'DELETE' }).then((r) => r.data),
  orders: () => admin('/orders').then((r) => r.data),
  markOrderForwarded: (id, note = null) =>
    admin(`/orders/${id}/forwarded`, { method: 'POST', data: { note } }).then((r) => r.data),
  markOrderDispatched: (id, note = null) =>
    admin(`/orders/${id}/dispatched`, { method: 'POST', data: { note } }).then((r) => r.data),
  reopenOrder: (id) =>
    admin(`/orders/${id}/reopen`, { method: 'POST', data: {} }).then((r) => r.data),
  weeklyPulse: () => admin('/weekly-pulse').then((r) => r.data),
};
